/* eslint-disable  */

import { APIClient } from "./_api";
const endpoint = "/Dashboard";

//seting
export function getAllOrderStatus() {
  return APIClient.get(`${endpoint}/orderstatus`);
}

export function getAllOrderCanceled() {
  return APIClient.get(`${endpoint}/canceledStatus`);
}
export function getAllCustomer() {
  return APIClient.get(`${endpoint}/customer`);
}
export function getAllAmounts() {
  return APIClient.get(`${endpoint}/amounts`);
}
export function getAllTransactions() {
  return APIClient.get(`${endpoint}/transactions`);
}
